type Props = {
	title: string
	subtitle?: string
}

export function ScreenHeading({ title, subtitle }: Props) {
	return (
		<div className="flex flex-col gap-2 text-center">
			<h2 className="text-2xl font-bold tracking-tight text-brand-800 sm:text-3xl">{title}</h2>
			{subtitle && <p className="text-base text-muted-foreground">{subtitle}</p>}
		</div>
	)
}
